(function () {

    function fixSelectFromListAccessibility() {

        const selectors = document.querySelectorAll('.select-from-list');

        selectors.forEach(function (container) {

            const label = container.querySelector('label');
            const listbox = container.querySelector('[role="listbox"]');
            const button = container.querySelector('button[aria-controls]');

            if (!label) {
                return;
            }

            const labelText = label.textContent
                .replace(/\s+/g, ' ')
                .trim();

            if (listbox && label.id) {
                listbox.setAttribute(
                    'aria-labelledby',
                    label.id
                );
            }

            if (button && labelText) {
                button.setAttribute(
                    'aria-label',
                    'Abrir opciones de ' + labelText
                );
            }
        });
    }

    function init() {

        fixSelectFromListAccessibility();

        const observer = new MutationObserver(function () {
            fixSelectFromListAccessibility();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {

        document.addEventListener('DOMContentLoaded', function () {
            init();
        });

    } else {

        init();
    }

})();